import { useEffect, useRef } from 'react';

/**
 * Hook to automatically scroll a ref element to bottom when dependencies change
 * Useful for chat interfaces, activity feeds, etc.
 */
export function useAutoScroll<T extends HTMLElement>(
  /**
   * Dependencies that trigger auto-scroll (e.g., message count)
   */
  dependencies: React.DependencyList
) {
  const scrollRef = useRef<T>(null);

  useEffect(() => {
    if (dependencies.some((dep) => dep !== undefined && dep !== null)) {
      setTimeout(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return scrollRef;
}
